<template>
  <div class="kline_chart">
    <!-- K 线部分 -->
    <div class="main_kline">
      <div class="echart_header">
        <div class="echart_title">
          <div class="left_text_p">
            <span class="name_text">
              {{ contractData.coin }}{{ $t('永续') }}
            </span>
            <div class="price_box">
              <div
                :class="{
                  current_up: Number(contractData.change) > 0,
                  current_down: Number(contractData.change) < 0,
                }"
                class="dollar_text"
              >
                {{ contractData.price }}
              </div>
            </div>
            <div class="key_descrition">
              <p>{{ $t('涨幅') }}</p>
              <p
                :class="{
                  current_up: Number(contractData.change) > 0,
                  current_down: Number(contractData.change) < 0,
                }"
                class="value_num"
              >
                {{ Number(contractData.change) > 0 ? '+' : ''
                }}{{ contractData.change | initFilter('---') }}%
              </p>
            </div>
            <div class="key_descrition">
              <p>24H {{ $t('高') }}</p>
              <p class="value_num">
                {{ contractData.high | initFilter('---') }}
              </p>
            </div>
            <div class="key_descrition">
              <p>24H {{ $t('低') }}</p>
              <p class="value_num">
                {{ contractData.low | initFilter('---') }}
              </p>
            </div>
            <div class="key_descrition">
              <p>24H {{ $t('量') }}</p>
              <p class="value_num">
                {{ contractData.volume | initFilter('---') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="config_box">
        <div class="config_box--left">
          <button
            v-for="item in timeList"
            :key="item"
            :class="{ active: item === interval }"
            @click="changeInterval(item)"
          >
            {{ item }}
          </button>
        </div>
        <div class="config_box--right">
          <el-popover placement="bottom-end" trigger="click">
            <span slot="reference" class="indicator-btn">
              {{ $t('指标') }}<i class="el-icon-arrow-down"></i>
            </span>
            <div class="indicator-title" :style="indicatorTitleStyle">
              {{ $t('主要指标') }}
            </div>
            <div>
              <el-button
                v-for="item in ['MA', 'BOLL']"
                :key="item"
                :type="item === indicator[0] ? 'primary' : ''"
                size="small"
                @click="chagneIndicator([item, indicator[1]])"
              >
                {{ item }}
              </el-button>
              <div style="height: 10px"></div>
              <div class="indicator-title" :style="indicatorTitleStyle">
                {{ $t('高级指标') }}
              </div>
              <div>
                <el-button
                  v-for="item in ['VOL', 'MACD', 'KDJ', 'RSI', 'WR']"
                  :key="item"
                  :type="item === indicator[1] ? 'primary' : ''"
                  size="small"
                  @click="chagneIndicator([indicator[0], item])"
                >
                  {{ item }}
                </el-button>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="echart_box">
        <EchartKLine />
      </div>
    </div>
  </div>
</template>
<script>
import EchartKLine from './EchartKLine'

import { mapState } from 'vuex'
export default {
  components: {
    EchartKLine,
  },
  data() {
    return {
      indicatorTitleStyle: {
        color: 'rgb(20,20,20)',
        marginBottom: '5px',
      },
      timeList: ['1m', '5m', '15m', '30m', '1H', '1D', '1M'],
    }
  },
  computed: {
    ...mapState('contract', ['contractData', 'indicator', 'interval']),
  },
  methods: {
    chagneIndicator(val) {
      this.$store.commit('contract/SET_INDICATOR', val)
    },
    changeInterval(val) {
      this.$store.commit('contract/SET_INTERVAL', val)
    },
  },
}
</script>
<style lang="less" scoped>
.kline_chart {
  .main_kline {
    .echart_header {
      padding: 7px 10px;
      background-color: @titleBgColor1;
      .echart_title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .left_text_p {
          display: flex;
          flex-direction: row;
          align-items: center;
          .name_text {
            margin-right: 25px;
            font-size: 16px;
            font-family: PingFangSC-Medium, 'PingFang SC';
            font-weight: 500;
            color: @textColor1;
            line-height: 22px;
          }
          .price_box {
            margin-right: 20px;
            .dollar_text {
              margin-right: 10px;
              height: 25px;
              font-size: 18px;
              font-family: PingFangSC-Medium, 'PingFang SC';
              font-weight: 500;
              color: @textColor4;
              line-height: 25px;
            }
            // 动态控制字体颜色
            .current_up {
              color: #3baf7c;
            }
            .current_down {
              color: #ff3f4a;
            }
          }
        }
        .key_descrition {
          margin-right: 35px;
          font-size: 14px;
          font-weight: 400;
          color: @textColor5;
          line-height: 20px;
          .value_num {
            font-size: 14px;
            font-family: PingFangSC-Regular, 'PingFang SC';
            font-weight: 400;
            color: @textColor4;
            line-height: 20px;
          }
          // 动态控制字体颜色
          .current_up {
            color: #3baf7c;
          }
          .current_down {
            color: #ff3f4a;
          }
        }
      }
    }
    .echart_box {
      height: 442px;
      background: @contentBgColor1;
    }
    .config_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      background: @contentBgColor1;
      &--left {
        font-size: 14px;
        font-weight: 400;
        color: #7d84a1;

        button {
          outline: none;
          border: none;
          background: none;
          cursor: pointer;
          color: var(--textColor4, #d2d7ec);
          &:not(:last-child) {
            margin-right: 20px;
          }
          &.active {
            color: #42b3fa;
          }
          &:disabled {
            cursor: not-allowed;
          }
        }
      }
      &--right {
        display: flex;
        .indicator-btn {
          color: @textColor5;
          cursor: pointer;
          // color: red;
        }
      }
    }
  }
}
</style>
